exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-social__title{display:block;margin-bottom:12.5px;font-size:16px;font-weight:500}@media screen and (max-width:767px){.footer-social__title{margin-top:12.5px;text-align:center}}input[type=text].footer-social__input{margin-bottom:6.25px}@media screen and (min-width:768px) and (max-width:960px){input[type=text].footer-social__input{line-height:36px}}@media screen and (min-width:768px) and (max-width:960px){.button.footer-social__submit{padding:0 10px;font-size:1.4rem;line-height:36px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/footer/footer-social/footer-social.styl
// module id = 519
// module chunks = 0